<template>
  <section>
    <notifications></notifications>
    <sidebar-help
      :title="$route.name"
      :items="guides"
      :loader="loader"
      :toggleSidebar="visibleSideBar"
      @closeSidebar="closeSidebar"
    />

    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-4 col-md-6 col-sm-6 col-6 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.name }}</h1>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-6 col-6 text-right">
          <div class="box-buttons">
            <base-button
              type="primary"
              @click="$router.push('/tools/destinations/new')"
              class="min-button"
            >
              <i class="flaticon-plus"></i>New
              <span class="d-lg-block d-none ml-1">Destination</span>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="main-buttons">
        <div class="row">
          <div
            class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 align-self-center mb-0"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search">
                <b-input-group-prepend class="pt-1 pl-1">
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model.trim="simpleSearch"
                  v-on:input="applySimpleSearch"
                  type="search"
                  placeholder="Search Anything..."
                  class="border-none"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div
            class="col-xl-8 col-lg-8 col-md-6 col-sm-6 col-12 alinmov2 align-self-center"
          >
            <div class="box-buttons">
              <base-button
                type="outline-neutral"
                class="min-button"
                v-if="activeFilter"
                @click="resetSearchFilter()"
              >
                <i class="flaticon-eraser"></i>
                <span class="d-lg-block d-none ml-1">Reset Search</span>
              </base-button>

              <base-dropdown
                menu-on-right
                class="nav-item"
                tag="li"
                title-tag="a"
                title-classes="btn min-button btn-outline-neutral "
                title="Actions"
              >
                <base-button slot="title" type="none" class="p-0 min-button">
                  <i class="flaticon-rec"></i>
                  <strong class="d-lg-block d-none ml-1">Status</strong>
                </base-button>
                <div
                  class="dropdown-item"
                  v-for="filter in status"
                  :class="destinationStatus === filter.value ? 'active' : ''"
                  :key="filter.value"
                  @click="applyFilterByDestinationStatus(filter.value)"
                >
                  <i :class="filter.icon"></i>
                  {{ filter.label }}
                </div>
              </base-dropdown>

              <base-dropdown
                menu-on-right
                class="nav-item"
                tag="li"
                title-tag="a"
                title-classes="btn min-button btn-outline-neutral "
                title="Type"
              >
                <base-button slot="title" type="none" class="p-0 min-button">
                  <i class="flaticon-ammunition"></i>
                  <strong class="d-lg-block d-none ml-1">Visibility</strong>
                </base-button>

                <div
                  class="dropdown-item"
                  v-for="filter in VisibilityStatus"
                  :key="filter.value"
                  :class="
                    destinationVisibilityStatus === filter.value ? 'active' : ''
                  "
                  @click="applyFilterByVisibilityStatus(filter.value)"
                >
                  <i :class="filter.icon"></i>
                  {{ filter.label }}
                </div>
              </base-dropdown>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div
                class="col-12 pt-0 pb-3 text-right"
                v-if="activeFilter || sortBy"
              >
                <template v-if="activeFilter">
                  <span><strong>Filtered by: </strong></span>
                  <ul class="box-tags-filters">
                    <li class="tags-filters" v-if="filters.status">
                      Status: {{ filters.status }}
                    </li>
                    <li class="tags-filters" v-if="filters.visibilityStatus">
                      Visibility Status: {{ filters.visibilityStatus }}
                    </li>

                    <li class="tags-filters" v-if="simpleSearch">
                      {{ simpleSearch }}
                    </li>

                    <li class="d-inline-block">
                      <span @click="resetSearchFilter()" class="curp"
                        ><i class="flaticon-cancel ml-2"></i
                      ></span>
                    </li>
                  </ul>
                </template>
                <template v-if="sortBy">
                  <span class="ml-3"><strong>Local Sorted by:</strong></span>
                  <ul class="box-tags-filters">
                    <li class="tags-filters">
                      {{ getSortName(sortBy, sortDesc) }}
                    </li>
                    <li class="d-inline-block">
                      <span @click="resetSortAction()" class="curp"
                        ><i class="flaticon-cancel ml-2"></i
                      ></span>
                    </li>
                  </ul>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box-table">
        <div class="row">
          <div
            class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2"
          >
            <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
              <b-form-radio-group
                id="radio-group-2"
                v-model="destinationType"
                :aria-describedby="ariaDescribedby"
                name="radio-sub-component"
                button-variant="type-tab"
                buttons
                @change="onChangeDestinationType"
                class="buttons-rows-2"
              >
                <b-form-radio value="CITIES"
                  >Cities
                  <badge
                    type="danger"
                    class="square"
                    v-if="unpublishedCities > 0"
                    >{{ unpublishedCities }}</badge
                  ></b-form-radio
                >
                <b-form-radio value="COUNTRIES"
                  >Countries<badge
                    type="danger"
                    class="square"
                    v-if="unpublishedCountries > 0"
                    >{{ unpublishedCountries }}</badge
                  ></b-form-radio
                >
              </b-form-radio-group>
            </b-form-group>
          </div>

          <div
            class="col-xl-7 col-lg-5 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 text-right"
          >
            <div
              class="col-xl-7 col-lg-12 col-md-6 ml-auto d-inline-block mb-xl-0 mb-1"
            >
              <b-form-group
                label="Sort"
                label-for="sort-by-select"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                v-slot="{ ariaDescribedby }"
                class="mb-0"
                size="sm"
              >
                <b-input-group>
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="sortOptions"
                    @change="applySortBy"
                    :aria-describedby="ariaDescribedby"
                    class="w-70"
                    size="sm"
                  >
                    <template #first>
                      <option value="">-- None --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    @change="applySortType"
                    :aria-describedby="ariaDescribedby"
                    class="w-30"
                    size="sm"
                  >
                    <option :value="'asc'">Asc</option>
                    <option :value="'desc'">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2">
              <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="view"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="changeViewCard"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card"
                    ><i class="flaticon-menu" title="View Card"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <div class="d-inline-block">
              <el-tooltip content="Help" placement="bottom">
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="openSideBar"
                >
                  <i class="flaticon-question-1 f-16 mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>

        <pagination-block
          :pageCount="pageCount"
          :total="totalRows"
          v-model="currentPage"
          :limit="limit"
          @changeLimit="changeLimit"
          @changePage="changePage"
          @nextPage="nextPage"
          @prevPage="prevPage"
          position="bottom"
        />
        <b-table
          hover
          :items="records"
          :fields="headers"
          sort-by.sync="title"
          sort-asc.sync="true"
          selectable
          select-mode="multi"
          ref="selectableTable"
          sort-icon-left
          responsive
          show-empty
          empty-filtered-text="There are no records matching your request"
          empty-text="There are no records to show"
          :stacked="cardview"
        >
          <!--Commons-->
          <template #cell(name)="data">
            <div class="d-flex align-items-center min-img-product">
              <LazyImage
                :src="
                  data.item.article.thumbnail
                    ? data.item.article.thumbnail
                    : noPreview
                "
                imgClasses="img-experience-min"
                beforeClasses="d-inline-flex"
              />
              <router-link
                :to="
                  `/tools/destinations/${
                    data.item._id
                  }?type=${getDestinationType(data.item)}`
                "
                class="title multiline-3 d-inline-flex"
              >
                <span
                  class="username hide-data"
                  v-if="destinationType === 'CITIES'"
                >
                  {{ data.item.city }}</span
                >
                <span class="username hide-data" v-else>
                  {{ data.item.name }}</span
                >
              </router-link>
            </div>
          </template>

          <template #cell(type)="data">
            <span
              class="username hide-data"
              v-if="destinationType === 'CITIES'"
            >
              City</span
            >
            <span class="username hide-data" v-else> Country</span>
          </template>

          <template #cell(code)="data">
            <span class="hide-data">{{ data.item.iata_code }}</span>
            <span class="hide-data">{{ data.item.code }}</span>
          </template>

          <template #cell(country)="data">
            <span
              class="hide-data"
              v-if="destinationType === 'CITIES' && data.item.country"
              >{{ data.item.country.name }}</span
            >
          </template>

          <template #cell(description)="data">
            <span
              class="multiline-3"
              v-if="data.item.article.description != ''"
            >
              {{ data.item.article.description }}</span
            >

            <span class="text-warning" v-else> Pending </span>
          </template>

          <template #cell(citiesCount)="data">
            <span class="hide-data">{{ data.item.citiesCount }}</span>
          </template>

          <template #cell(visibilityStatus)="data">
            <el-tooltip content="Visibility on web" placement="bottom">
              <div
                class="capitalize badge-status"
                v-bind:class="
                  generateVisibilityStatusClass(data.item.visibilityStatus)
                "
              >
                {{ formatVisibilityStatus(data.item.visibilityStatus) }}
              </div></el-tooltip
            >
          </template>

          <template #cell(status)="data">
            <el-tooltip content="For use in rates" placement="bottom">
              <div
                class="capitalize badge-status"
                v-bind:class="generateStatusClass(data.item.status)"
              >
                {{ formatDestinationStatus(data.item.status) }}
              </div></el-tooltip
            >
          </template>

          <template #cell(actions)="data">
            <template>
              <el-tooltip content="View Destination" placement="bottom">
                <router-link
                  class="icon-action text-info"
                  :to="
                    `/tools/destinations/${
                      data.item._id
                    }?type=${getDestinationType(data.item)}`
                  "
                >
                  <i class="flaticon-visualization text-primary"></i>
                </router-link>
              </el-tooltip>

              <el-tooltip content="Change status" placement="bottom">
                <span
                  class="icon-action text-info ml-2"
                  @click.stop="changeStatus(destinationType, data.item._id)"
                >
                  <i class="flaticon-right-4"></i>
                </span>
              </el-tooltip>
            </template>
          </template>
        </b-table>

        <pagination-block
          :pageCount="pageCount"
          :total="totalRows"
          v-model="currentPage"
          :limit="limit"
          @changeLimit="changeLimit"
          @changePage="changePage"
          @nextPage="nextPage"
          @prevPage="prevPage"
          position="bottom"
        />
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import WSelect from "@/components/Select";
import Swal from "sweetalert2";
import { CountriesAPI, DestinationsAPI, DocumentsAPI } from "@/core/api";
import { goBack } from "@/helpers/commons.helpers";
import {
  getDestinationId,
  getDestinationType
} from "../services/rules.services";
import {
  HEADERS_CITIES,
  HEADERS_COUNTRIES
} from "../constants/tables.constants";
import {
  formatDestinationStatus,
  formatVisibilityStatus,
  generateStatusClass,
  generateVisibilityStatusClass
} from "../services/format.services";
import { handleApiError } from "@/core/services";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "Destinations",
  data() {
    return {
      currentPage: 1,
      headers: HEADERS_CITIES,
      cardview: false,
      limit: 0,
      query: "",
      sortBy: "",
      sortDesc: "asc",
      sortOptions: [
        { value: "name", text: "Name" },
        { value: "code", text: "Code" },
        { value: "status", text: "Status" }
      ],
      timeoutId: null,
      view: "table",
      activeFilter: false,
      simpleSearch: "",
      filters: {
        visibilityStatus: "",
        status: ""
      },
      destinationType: "CITIES",
      destinationVisibilityStatus: "CITIES",
      destinationStatus: "",
      VisibilityStatus: [
        {
          label: "Pending to Complete",
          value: "PENDING",
          icon: "flaticon-time-left text-warning"
        },
        {
          label: "Published on Web",
          value: "PUBLISHED",
          icon: "flaticon-bold-check-3 text-success"
        }
      ],
      status: [
        {
          label: "Active",
          value: "ACTIVE",
          icon: "flaticon-rec text-success "
        },
        {
          label: "Inactive",
          value: "INACTIVE",
          icon: "flaticon-rec text-danger"
        }
      ],
      loader: false,
      guides: [],
      visibleSideBar: false,
      unpublishedCities: 0,
      unpublishedCountries: 0,
      noPreview: require("rhomtrip_assets/src/img/no-image-available.png")
    };
  },
  async mounted() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },
      {
        text: "Tools",
        to: "/tools"
      },
      {
        text: "Destinations",
        active: true
      }
    ];
    this.setItemsBread(bread);
  },
  async created() {
    await this.getLimit();
    this.limit = this.paginationLimit;
    this.destinationType = this.destinationSearchCriteria.destinationType
      ? this.destinationSearchCriteria.destinationType
      : "CITIES";
    this.headers = this.getTableHeaders(this.destinationType);
    this.currentPage = this.destinationSearchCriteria.currentPage;
    this.query = this.destinationSearchCriteria.query;
    this.initializeFilterData(this.query);
    this.activeFilter = this.query ? true : false;
    this.get(true, this.limit, this.currentPage, this.query);
  },
  methods: {
    getDestinationId,
    getDestinationType,
    generateStatusClass,
    formatDestinationStatus,
    generateVisibilityStatusClass,
    formatVisibilityStatus,
    async resetSearchFilter() {
      this.query = "";
      this.filters = { visibilityStatus: "", status: "" };
      this.currentPage = 1;
      this.simpleSearch = "";
      this.activeFilter = this.query ? true : false;
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },
    addElementInQuery(query, key, value) {
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, value ? value.trim() : value);
      } else {
        searchParams.append(key, value ? value.trim() : value);
      }
      return searchParams.toString();
    },
    async get(loader, limit, page, query) {
      const payload = { loader, limit, page, query };
      if (this.destinationType === "CITIES") {
        this.getDestinations(payload);
      } else {
        this.getCountries(payload);
      }
      this.setDestinationSearchCriteria({
        destinationType: this.destinationType,
        currentPage: page,
        limit: limit,
        query: query,
        status: true
      });

      const {
        unpublishedCities,
        unpublishedCountries
      } = await this.getUnpublishedCounts();
      this.unpublishedCities = unpublishedCities;
      this.unpublishedCountries = unpublishedCountries;
    },
    async applySortBy(value) {
      this.query = this.addElementInQuery(this.query, "sortBy", value);
      this.query = this.addElementInQuery(
        this.query,
        "sortType",
        this.sortDesc
      );
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    async applySortType(value) {
      this.query = this.addElementInQuery(this.query, "sortBy", this.sortBy);
      this.query = this.addElementInQuery(this.query, "sortType", value);
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    async resetSortAction() {
      this.sortBy = "";
      this.sortDesc = false;
      this.query = this.deleteItemInQuery(this.query, ["sortBy", "sortType"]);
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    prevPage(page) {
      this.get(true, this.limit, page, this.query);
    },
    nextPage(page) {
      this.get(true, this.limit, page, this.query);
    },
    changePage(page) {
      this.get(true, this.limit, page, this.query);
    },
    changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        this.get(true, this.limit, this.currentPage, this.query);
      }
    },
    changeViewCard(value) {
      this.cardview = !(value === "table");
    },
    goToPreviousPage() {
      goBack(this);
    },
    initializeFilterData(query) {
      let searchCriteria = new URLSearchParams(query);
      this.simpleSearch = searchCriteria.has("search")
        ? searchCriteria.get("search")
        : "";
      this.filters.status = searchCriteria.has("status")
        ? searchCriteria.get("status")
        : "";
      this.destinationStatus = this.filters.status || "ACTIVE";

      this.filters.visibilityStatus = searchCriteria.has("visibilityStatus")
        ? searchCriteria.get("visibilityStatus")
        : "";
      this.destinationVisibilityStatus =
        this.filters.visibilityStatus || "PUBLISHED";
    },
    async applySimpleSearch(value) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        this.currentPage = 1;
        if (value) {
          this.query = this.addElementInQuery(this.query, "search", value);
          this.activeFilter = this.query ? true : false;
          await this.get(true, this.limit, this.currentPage, this.query);
        } else {
          this.query = this.deleteItemInQuery(this.query, ["search"]);
          this.activeFilter = this.query ? true : false;
          await this.get(true, this.limit, this.currentPage, this.query);
        }
      }, 500);
    },
    getTableHeaders(destinationType) {
      if (destinationType === "CITIES") {
        return HEADERS_CITIES;
      } else if (destinationType === "COUNTRIES") {
        return HEADERS_COUNTRIES;
      }
    },
    onChangeDestinationType(destinationType) {
      this.currentPage = 1;
      this.headers = this.getTableHeaders(destinationType);
      this.get(true, this.limit, this.currentPage, this.query);
    },
    applyFilterByVisibilityStatus(value) {
      this.filters.visibilityStatus = value;
      this.destinationVisibilityStatus = value;
      this.currentPage = 1;
      this.query = this.addElementInQuery(
        this.query,
        "visibilityStatus",
        value
      );
      this.activeFilter = this.query ? true : false;
      this.get(true, this.limit, this.currentPage, this.query);
    },
    applyFilterByDestinationStatus(value) {
      this.filters.status = value;
      this.destinationStatus = value;
      this.currentPage = 1;
      this.query = this.addElementInQuery(this.query, "status", value);
      this.activeFilter = this.query ? true : false;
      this.get(true, this.limit, this.currentPage, this.query);
    },
    async deleteDestination(destinationId) {
      let { value } = await Swal.fire({
        title: "Delete Destination",
        text: "Are you sure do you want to delete this Destination?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        cancelButtonClass: "btn btn-secondary btn-small-one",
        confirmButtonText: "Yes",
        confirmButtonClass: "btn btn-primary btn-small-one",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteDestinationById(destinationId);
      }
    },
    async deleteDestinationById(destinationId) {
      try {
        this.setLoad(true);
        let { data } =
          this.destinationType === "CITIES"
            ? await DestinationsAPI.deleteDestinationById(
                destinationId,
                this.sesion.token
              )
            : await CountriesAPI.deleteCountryBySlug(
                destinationId,
                this.sesion.token
              );

        this.setLoad(false);
        if (data.data.deleted) {
          this.get(true, this.limit, this.currentPage, this.query);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Destination has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    async getUnpublishedCounts() {
      try {
        let { data } = await CountriesAPI.getUnpublishedCounts(
          this.sesion.token
        );
        return data.data;
      } catch (error) {
        return { unpublishedCities: 0, unpublishedCountries: 0 };
      }
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async openSideBar() {
      this.visibleSideBar = true;
      this.loader = true;
      this.guides = await this.getSupportDocuments("INTERNAL", "DESTINATIONS");
      this.loader = false;
    },
    async getSupportDocuments(app, module) {
      try {
        let { data } = await DocumentsAPI.getSupportDocuments(
          app,
          module,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    async changeStatus(destinationType, destinationId) {
      let { value } = await Swal.fire({
        title: "Change Status",
        html: `Are you sure do you want change status the selected Destination?<br><br>The Destination isn't available to assign in the Rates`,
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        cancelButtonClass: "btn btn-secondary btn-small-one",
        confirmButtonText: "Yes",
        confirmButtonClass: "btn btn-primary btn-small-one",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        if (destinationType === "CITIES") {
          await this.changeDestinationStatusById(destinationId);
          return;
        }

        if (destinationType === "COUNTRIES") {
          await this.changeCountryStatusById(destinationId);
          return;
        }
      }
    },
    async changeDestinationStatusById(destinationId) {
      try {
        this.setLoad(true);
        let { data } = await DestinationsAPI.changeDestinationStatusById(
          destinationId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Destination status has been changed",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      } finally {
        this.setLoad(false);
        this.get(true, this.limit, this.currentPage, this.query);
      }
    },
    async changeCountryStatusById(countryId) {
      try {
        this.setLoad(true);
        let { data } = await CountriesAPI.changeCountryStatusById(
          countryId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Country status has been changed",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      } finally {
        this.setLoad(false);
        this.get(false, this.limit, this.currentPage, this.query);
      }
    },
    handleError(error, message) {
      handleApiError(this, error, message);
    },
    isInDestinationsModule(modules = []) {
      if (!modules.includes("destinations")) {
        this.setDestinationSearchCriteria({
          destinationType: "CITIES",
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    getSortName(sortBy, sortDesc) {
      let sortOption = this.sortOptions.find(option => option.value === sortBy);
      if (sortOption) {
        return `${sortOption.text} - ${sortDesc.toUpperCase()}`;
      }
      return "";
    },
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setDestinationSearchCriteria"
    ]),
    ...mapActions(["getLimit", "getCountries", "getDestinations"])
  },
  computed: {
    records: function() {
      if (this.destinationType === "CITIES") {
        return this.destinations.docs ? this.destinations.docs : [];
      } else if (this.destinationType === "COUNTRIES") {
        return this.countriesService.docs ? this.countriesService.docs : [];
      } else {
        return this.destinations.docs;
      }
    },
    totalRows: function() {
      if (this.destinationType === "CITIES") {
        return this.destinations.count;
      } else if (this.destinationType === "COUNTRIES") {
        return this.countriesService.count;
      } else {
        return 0;
      }
    },
    pageCount: function() {
      if (this.destinationType === "CITIES") {
        return this.destinations.pages;
      } else if (this.destinationType === "COUNTRIES") {
        return this.countriesService.pages;
      } else {
        return 0;
      }
    },
    ...mapGetters([
      "sesion",
      "sigout",
      "paginationLimit",
      "destinationSearchCriteria",
      "countriesService",
      "destinations"
    ])
  },
  destroyed() {
    clearTimeout(this.timeoutId);
  },
  beforeRouteLeave(to, from, next) {
    this.isInDestinationsModule(to.meta.modules);
    next();
  },
  components: {
    WSelect: WSelect,
    flatPickr,
    Swal
  }
};
</script>
